import { FormattedHTMLMessage } from 'react-intl';
import styled, { FlattenSimpleInterpolation } from 'styled-components/macro';
import tw from 'tailwind.macro';
import clientReviewsGreen from '../../images/ClientReviewsGreen.svg';
import { P0 } from '../Typographies/Paragraph';
import messages from './messages';

interface TrustBoxProps {
  customStyle?: FlattenSimpleInterpolation;
}

const TrustBoxContainer = styled.div<TrustBoxProps>`
  ${tw` flex items-center justify-center md:justify-start `}
  width:max-content;
  gap: var(--size-tiny);

  img {
    height: 18px;
  }

  ${({ customStyle }) => customStyle && customStyle}
`;

const TrustBox: React.FC<TrustBoxProps> = ({ customStyle }) => (
  <TrustBoxContainer customStyle={customStyle}>
    <img alt="4 stars icon" src={clientReviewsGreen} />
    <P0>
      <FormattedHTMLMessage {...messages.review} />
    </P0>
  </TrustBoxContainer>
);

export default TrustBox;
